import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../constants';

import { generateScelliusFormToken } from '../../../services/scellius/actions';

import SvgComponent from '../../SvgComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './ScelliusComponents.scss';

const ScelliusComponent = ({
    i18n,
    i18nForm,
    orderId,
    partnerId,
    userInfo,
    scelliusTokenLoading,
    scelliusTokenError,
    scelliusFormToken,
    onGenerateScelliusFormToken
}) => {
    useEffect(() => {
        onGenerateScelliusFormToken(orderId, partnerId, userInfo);

        return function cleanup() {
            scelliusFormToken = null;
        };
    }, []);

    useEffect(() => {
        if (scelliusFormToken && typeof KR !== 'undefined') {
            // KR is a global variable for Scellius, created by script in index.html
            // eslint-disable-next-line no-undef
            KR.setFormToken(scelliusFormToken);
        }
        // eslint-disable-next-line no-undef
    }, [scelliusFormToken, KR]);

    return (
        <div id="scellius-container">
            <h3>{i18n.PAYMENT_CHOICE.CB}</h3>

            <div className="scellius-wrapper">
                {scelliusTokenLoading && <LoadingComponent />}

                {scelliusTokenError && (
                    <p>Une erreur est survenue lors du chargement du module de paiement</p>
                )}

                {!scelliusTokenLoading && !!scelliusFormToken && (
                    <div>
                        <div className="kr-embedded">
                            <div className="kr-group">
                                <div className="kr-input-item">
                                    <div className="kr-label">{i18n.FORM.PAN_LABEL}</div>
                                    <div className="kr-pan"></div>
                                </div>
                                <div className="kr-input-item">
                                    <div className="kr-label">{i18n.FORM.EXP_LABEL}</div>
                                    <div className="kr-expiry"></div>
                                </div>
                            </div>
                            <div className="kr-group">
                                <div className="kr-input-item">
                                    <div className="kr-label">{i18n.FORM.CCV_LABEL}</div>
                                    <div className="kr-security-code"></div>
                                </div>
                                <div className="kr-input-item">
                                    <div className="kr-label">{i18n.FORM.CARD_HOLDER_NAME}</div>
                                    <div className="kr-card-holder-name"></div>
                                </div>
                            </div>
                            <div className="kr-group">
                                <button className="kr-payment-button"></button>
                            </div>
                            <div className="kr-do-register"></div>
                            <div className="kr-form-error"></div>
                        </div>
                    </div>
                )}
            </div>

            <div className="lock-container">
                <SvgComponent
                    src={`${STATIC_ROOT}/lockpad.svg`}
                    width="14"
                    height="14"
                    aria-hidden="true"
                    focusable="false"
                />
                <span className="lockpad-label">{i18nForm.PAYMENT_LOCKPAD_LABEL}</span>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        i18nForm: state.i18n.feature.form,
        scelliusTokenLoading: state.scellius.loading,
        scelliusFormToken: state.scellius.formToken,
        scelliusError: state.scellius.error
    };
};
const mapDispatchToProps = dispatch => ({
    onGenerateScelliusFormToken: (orderId, partnerId, userInfo) =>
        dispatch(generateScelliusFormToken(orderId, partnerId, userInfo))
});

export default connect(mapStateToProps, mapDispatchToProps)(ScelliusComponent);



// WEBPACK FOOTER //
// ./src/components/iframes/scellius/ScelliusComponent.js